export default __webpack_public_path__ + "static/media/Trippimg_094.37a3cd25.jpg";